<script>
    export let value = [];
    let newOpt = "";

    function addOption() {
        if (!newOpt) return;
        
        value = [...value, newOpt];
        newOpt = "";
    }

    function removeOption(opt) {
        value = value.filter(o => o != opt);
    }
    
    function checkEnter(e) {
        if (e.key == "Enter") {
            addOption()
            e.preventDefault();
            e.stopPropagation();
            return false
        }
    }
</script>

<ul>
    {#each value as opt}
        <li>{opt} <span class="delete" on:click={() => removeOption(opt)}></span></li>
    {/each}
</ul>
<div class="field is-horizontal">
    <div class="field-label is-small">
        <label class="label">Add Option</label>
    </div>
    <div class="field-body">
        <div class="control">
            <input type="text" class="input is-small" bind:value={newOpt} on:keydown="{checkEnter}">
        </div>
        <div class="control">
            <span class="button" on:click={addOption}>Add</span>
        </div>
    </div>
</div>